// import { sortString, sortNumber, toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'DASHBOARD_SEARCH';

const initialState = () => ({
    loading: false,
    term: false,
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_SEARCH`: {
            const term = action.payload;
            return {
                ...state,
                term,
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};
export default reducer;